export default {
  paywall: {
    actions: {
      notNow: "Nicht jetzt",
      noThanks: "Nein danke",
      skip: "Überspringen",
    },
    generic: {
      title: "Schalte das volle Erlebnis frei",
      subtitle: "Greife auf alles zu, was du brauchst, um smarter zu recherchieren, zu bauen und zu wetten",
      whyJoin: "Warum Linemate+ beitreten?",
      comparePlans: "Pläne vergleichen",
      renewalDisclaimer: "Der Plan verlängert sich automatisch. Jederzeit kündbar.",
    },
    sources: {
      injuryImpact: {
        title: "Verletzungseinfluss freischalten",
        subtitle: "Sieh, wie Verletzungen Teamkollegen beeinflussen.\nAnalysiere jeden Trend tiefer",
      },
      startingLineups: {
        title: "Startaufstellungen freischalten",
        subtitle: "Finde Value, wenn sich Startaufstellungen ändern.\nAnalysiere jeden Trend tiefer",
      },
      opponentRank: {
        title: "Defensivrang des Gegners freischalten",
        subtitle: "Nutze günstige defensive Matchups.\nAnalysiere jeden Trend tiefer",
      },
      weatherReport: {
        title: "Wetterbericht freischalten",
        subtitle: "Nutze Wind und Wetter zu deinem Vorteil.\nAnalysiere jeden Trend tiefer",
      },
      startingPitchers: {
        title: "Starting Opponent Pitchers freischalten",
        subtitle: "Ziele auf Spots gegen anfällige Pitcher.\nAnalysiere jeden Trend tiefer",
      },
    },
    features: {
      injuryImpact: {
        title: "Verletzungseinfluss",
        description: "Sieh, wie Verletzungen Teamkollegen beeinflussen.",
      },
      startingLineups: {
        title: "Startaufstellungen",
        description: "Finde Value, wenn sich Startaufstellungen ändern.",
      },
      opponentRank: {
        title: "Defensivrang des Gegners",
        description: "Nutze günstige defensive Matchups.",
      },
      weatherReport: {
        title: "Wetterbericht",
        description: "Nutze Wind und Wetter zu deinem Vorteil.",
      },
      startingPitchers: {
        title: "Starting Opponent Pitchers",
        description: "Ziele auf Spots gegen anfällige Pitcher.",
      },
    },
    comparison: {
      title: "Funktionen",
      free: "Kostenlos",
      rows: {
        dailyTeamAndPlayerTrends: "Tägliche Team- und Spielertrends",
        dailyParlayTrends: "Tägliche Kombiwetten-Trends",
        teamAndPlayerPropsTool: "Team- und Spieler-Props-Tool",
        statsAndStandings: "Stats und Tabellen",
        dailyCheatsheets: "Tägliche Cheatsheets",
        advancedSignalsAndTools: "Erweiterte Signale und Tools",
        startingLineups: "Startaufstellungen",
        injuryImpact: "Verletzungseinfluss",
        opponentDefensiveRank: "Defensivrang des Gegners",
        weatherReports: "Wetterberichte",
        startingOpponentPitchers: "Starting Opponent Pitchers",
      },
    },
    plans: {
      bestValue: "Bester Wert",
      annual: "Jährlich",
      monthly: "Monatlich",
      yearlyPlan: "Jahresplan",
      monthlyPlan: "Monatsplan",
      perYearShort: "Jahr",
      perMonthShort: "Monat",
    },
    onboarding: {
      trialTitle: "Starte deine 7-tägige kostenlose Testphase",
      trialSubtitle: "Wähle einen Plan, um nach Ende deiner Testphase fortzufahren",
    },
    cta: {
      claimYourCode: "Code einlösen",
      startYourFreeTrial: "Kostenlose Testphase starten",
      startMy7DayFreeTrial: "Meine 7-tägige kostenlose Testphase starten",
      tryFreeAndSubscribe: "Kostenlos testen und abonnieren",
      upgradeToLinematePlus: "Auf Linemate+ upgraden",
    },
    trial: {
      sevenDaysFree: "7 Tage kostenlos",
      thenPerMonth: "{{trial}}, danach {{price}} pro Monat",
      thenPerYear: "{{trial}}, danach {{price}} pro Jahr ({{monthlyPrice}}/{{perMonthShort}})",
      startingOn: " ab dem {{date}}",
      standardPerMonth: "{{price}} pro Monat",
      standardPerYear: "{{price}} pro Jahr ({{monthlyPrice}}/{{perMonthShort}})",
      subtitleSuffix: " mit einer 7-tägigen kostenlosen Testphase.",
    },
  },
};
